/**
 * Subtle ambient background — soft radial wash + faded grid only.
 * Toned down for the new "smart advertising" light aesthetic.
 */
export const BackgroundElements = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-[hsl(var(--primary)/0.04)]" />
      <div
        className="absolute inset-0 opacity-[0.35] dark:opacity-20"
        style={{
          backgroundImage:
            "radial-gradient(hsl(var(--primary) / 0.18) 1px, transparent 1px)",
          backgroundSize: "28px 28px",
          maskImage: "linear-gradient(to bottom, black 0%, transparent 60%)",
          WebkitMaskImage: "linear-gradient(to bottom, black 0%, transparent 60%)",
        }}
      />
      <div
        className="absolute -top-40 -right-32 w-[42rem] h-[42rem] rounded-full blur-3xl opacity-40 dark:opacity-25"
        style={{ background: "radial-gradient(circle, hsl(var(--primary) / 0.35), transparent 65%)" }}
      />
      <div
        className="absolute top-1/3 -left-40 w-[36rem] h-[36rem] rounded-full blur-3xl opacity-30 dark:opacity-20"
        style={{ background: "radial-gradient(circle, hsl(var(--primary-light) / 0.3), transparent 65%)" }}
      />
    </div>
  );
};
